// Angular Core
import {
  ApplicationRef,
  ChangeDetectorRef,
  Component,
  inject,
} from '@angular/core';

// Angular Material
import { MatDialogRef } from '@angular/material/dialog';

// Rxjs
import { take } from 'rxjs/operators';

// Third party

// Interfaces
import { IDialogData } from '@shared-module/interfaces';
import { SbiToastService } from '@shared-module/services/sbi-toast/sbi-toast.service';

@Component({
  selector: 'sbi-cot-back-default-elimination-dialog',
  templateUrl: './default-elimination-dialog.component.html',
  styleUrls: ['./default-elimination-dialog.component.scss'],
  standalone: false,
})
export class DefaultEliminationDialogComponent {
  private readonly _cdr = inject(ChangeDetectorRef);
  private readonly _toastr =
    inject(ApplicationRef).injector.get(SbiToastService);

  public data: IDialogData;
  public dialogRef: MatDialogRef<DefaultEliminationDialogComponent>;
  public isLoading = false;

  public initDialog(
    data: IDialogData,
    ref: MatDialogRef<DefaultEliminationDialogComponent>
  ): void {
    this.data = data;
    this.dialogRef = ref;
    this._cdr.detectChanges();
  }

  get messageParts(): { before: string; bold: string; after: string } {
    if (!this.data.boldText) {
      return { before: this.data.message, bold: '', after: '' };
    }
    const idx = this.data.message.indexOf(this.data.boldText);
    if (idx === -1) {
      return { before: this.data.message, bold: '', after: '' };
    }
    return {
      before: this.data.message.slice(0, idx),
      bold: this.data.boldText,
      after: this.data.message.slice(idx + this.data.boldText.length),
    };
  }

  public onConfirmClick(): void {
    if (!this.data.onConfirm) {
      this.dialogRef?.close({ confirmed: true });
      return;
    }

    this.isLoading = true;
    this._cdr.detectChanges();

    this.data
      .onConfirm()
      .pipe(take(1))
      .subscribe({
        next: () => {
          if (this.data.successMessage) {
            this._toastr.success(this.data.successMessage);
          }
          this.dialogRef?.close({ confirmed: true, success: true });
        },
        error: () => {
          if (this.data.errorMessage) {
            this._toastr.error(this.data.errorMessage);
          }
          this.dialogRef?.close({ confirmed: true, success: false });
        },
      });
  }

  public closeDialog(): void {
    this.dialogRef?.close();
  }
}
